'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../components/Language/index.js');
var index$1 = require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
require('../../components/ItemCard/index.js');
require('../../components/SelectItem/index.js');
require('../../components/SelectList/index.js');
require('../../components/ErrorBanner/index.js');
require('../../components/Footer/index.js');
require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/ItemCardSkeleton.js');
require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');
var FormFields = require('./FormFields.js');
var styles = require('./styles.js');
var tokens = require('./tokens.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const FormC = _ref => {
  let {
    onSubmit,
    onChange,
    giftReturn,
    fields,
    values,
    loading
  } = _ref;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(styles.FormWrapper, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginFormAbove"
  }), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.BigHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginTitle"
  })), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginTitleBelow"
  }), /*#__PURE__*/React__default["default"].createElement("p", {
    style: bodytextDefaultNone
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginDescription"
  })), loading ? /*#__PURE__*/React__default["default"].createElement(index$1["default"], null) : /*#__PURE__*/React__default["default"].createElement(FormFields.FormFields, {
    onSubmit,
    onChange,
    giftReturn,
    fields,
    values
  }), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginFormBelow"
  }));
};
const FormWrapped = props => {
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(styled.ThemeProvider, {
    theme: {
      bodytextDefaultNone
    }
  }, /*#__PURE__*/React__default["default"].createElement(FormC, props));
};
const Form = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(FormWrapped, {
  themeTokens: tokens.themeTokens
}), {
  translationKeys: tokens.translationKeys
});

exports.Form = Form;
